module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "c-atendimento",
    class: {
      'open': _vm.opened
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.solicitarRemocao($event)
      }
    }
  }, [_c('a', {
    staticClass: "btn c-a-close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-a-body"
  }, [(!_vm.atendimento.iniciado) ? _c('a', {
    staticClass: "w-full btn btn-danger",
    on: {
      "click": _vm.iniciarAtendimento
    }
  }, [_c('i', {
    staticClass: "fa fa-phone-volume"
  }), _vm._v(" "), (!_vm.loading) ? _c('span', {
    staticClass: "m-l"
  }, [_vm._v("Receber ligação e iniciar atendimento")]) : _c('span', [_vm._v("\n          Iniciando atendimento...\n        ")])]) : _c('div', {
    staticClass: "alert bg-black text-white text-center"
  }, [_vm._v("\n        Atendimento inciado em " + _vm._s(_vm._f("formatDate")(_vm.atendimento.data.date, 'DD/MM/YYYY HH:mm')) + " com o protocolo #" + _vm._s(_vm.atendimento.id) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_vm._v("Agente")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "disabled": !_vm.atendimento.iniciado,
      "options": _vm.agentesComputed,
      "placeholder": "Selecione um Agente"
    },
    model: {
      value: (_vm.atendimento.selAgente),
      callback: function($$v) {
        _vm.$set(_vm.atendimento, "selAgente", $$v)
      },
      expression: "atendimento.selAgente"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_vm._v("Classificação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atendimento.categoria),
      expression: "atendimento.categoria"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "disabled": !_vm.atendimento.iniciado
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.atendimento, "categoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione a classificação")]), _vm._v(" "), _vm._l((_vm.categoriaComputed), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.value
      }
    }, [_vm._v(_vm._s(cat.label))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.atendimento.semPlaca && !_vm.atendimento.firstPlaca) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "m-t"
  }, [_vm._v("Placa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atendimento.placa),
      expression: "atendimento.placa"
    }],
    ref: "placa",
    staticClass: "input-sm form-control",
    attrs: {
      "required": !_vm.atendimento.semPlaca && !_vm.atendimento.firstPlaca,
      "disabled": !_vm.atendimento.iniciado
    },
    domProps: {
      "value": (_vm.atendimento.placa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atendimento, "placa", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "m-t chassi"
  }, [_vm._v("Chassi")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atendimento.chassi),
      expression: "atendimento.chassi"
    }],
    ref: "chassi",
    staticClass: "input-sm form-control",
    attrs: {
      "disabled": !_vm.atendimento.iniciado
    },
    domProps: {
      "value": (_vm.atendimento.chassi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atendimento, "chassi", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "m-t semplaca"
  }, [_vm._v("Sem placa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atendimento.semPlaca),
      expression: "atendimento.semPlaca"
    }],
    ref: "semPlaca",
    staticClass: "form-control",
    attrs: {
      "type": "checkbox",
      "name": "semplaca",
      "disabled": !_vm.atendimento.iniciado
    },
    domProps: {
      "checked": Array.isArray(_vm.atendimento.semPlaca) ? _vm._i(_vm.atendimento.semPlaca, null) > -1 : (_vm.atendimento.semPlaca)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.atendimento.semPlaca,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.atendimento, "semPlaca", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.atendimento, "semPlaca", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.atendimento, "semPlaca", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "m-t first-placa"
  }, [_vm._v(" 1º Emplacamento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atendimento.firstPlaca),
      expression: "atendimento.firstPlaca"
    }],
    ref: "firstPlaca",
    staticClass: "form-control",
    attrs: {
      "type": "checkbox",
      "name": "semplaca",
      "disabled": !_vm.atendimento.iniciado
    },
    domProps: {
      "checked": Array.isArray(_vm.atendimento.firstPlaca) ? _vm._i(_vm.atendimento.firstPlaca, null) > -1 : (_vm.atendimento.firstPlaca)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.atendimento.firstPlaca,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.atendimento, "firstPlaca", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.atendimento, "firstPlaca", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.atendimento, "firstPlaca", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_vm._v("Modelo/Nome Veiculo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atendimento.nomeVeiculo),
      expression: "atendimento.nomeVeiculo"
    }],
    ref: "nomeVeiculo",
    staticClass: "input-sm form-control",
    attrs: {
      "disabled": !_vm.atendimento.iniciado
    },
    domProps: {
      "value": (_vm.atendimento.nomeVeiculo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atendimento, "nomeVeiculo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_vm._v("Recolher em")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atendimento.enderecoRecolhimento),
      expression: "atendimento.enderecoRecolhimento"
    }],
    ref: "enderecoRecolhimento",
    staticClass: "input-sm form-control",
    attrs: {
      "required": "",
      "disabled": !_vm.atendimento.iniciado
    },
    domProps: {
      "value": (_vm.atendimento.enderecoRecolhimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atendimento, "enderecoRecolhimento", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-xs bg-black text-white m-t-xs",
    class: {
      'disabled': !_vm.atendimento.iniciado
    },
    on: {
      "click": _vm.geocodeAddress
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker-alt"
  }), _vm._v(" Buscar no mapa\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_vm._v("Entregar em")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atendimento.patioDestino),
      expression: "atendimento.patioDestino"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.atendimento.iniciado
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.atendimento, "patioDestino", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione o pátio")]), _vm._v(" "), _vm._l((_vm.patiosComputed), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.value
      }
    }, [_vm._v(_vm._s(cat.label))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_vm._v("Reboquista")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atendimento.reboquista),
      expression: "atendimento.reboquista"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.atendimento.iniciado
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.atendimento, "reboquista", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione o reboquista")]), _vm._v(" "), _vm._l((_vm.reboques), function(reboque) {
    return _c('option', {
      domProps: {
        "value": reboque.id
      }
    }, [_vm._v(_vm._s(reboque.label))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "m-t-xl"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atendimento.observacoes),
      expression: "atendimento.observacoes"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "rows": "4",
      "disabled": !_vm.atendimento.iniciado,
      "placeholder": "Se tiver alguma observação, digite aqui"
    },
    domProps: {
      "value": (_vm.atendimento.observacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atendimento, "observacoes", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-success btn-solicitar",
    attrs: {
      "type": "submit",
      "disabled": !_vm.atendimento.iniciado
    }
  }, [_vm._v("\n          Solicitar Remoção ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d11d2a90","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/callcenter/components/Atendimento.vue
// module id = 1868
// module chunks = 17